'use strict';

import * as angular from 'angular';
import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';

class ModalContainerSaveFileController{
  /*@ngInject*/
  constructor($scope, $uibModalInstance, $timeout, container, options, mode) {
    $scope.container = container;
    $scope.mode = mode;
    $scope.directory = options.directory;

    function getSelected(){
      return $scope.activeSidebarTab.ctrl.getSelected();
    }

    $scope.$watch('activeSidebarTab', (post, pre) => {
      $timeout(() => {
        if(getSelected().length === 0) {
          const activeWindowModel = $scope.activeSidebarTab;
          if($scope.directory) {
            activeWindowModel.ctrl.getBodyController().selectFile($scope.directory);
          }else{
            const rootNode = activeWindowModel.model.node;
            rootNode.scope.select();
          }
        }
      }, 0);
    });
    let defaultFilename = 'untitled';
    const defaultExt = options.extensions && options.extensions[0];
    if(defaultExt) {
      defaultFilename = defaultFilename + '.' + defaultExt;
    }
    $scope.filename = defaultFilename;

    $scope.windowModels = [
      {
        application: 'file-tree',
        title: 'Home',
        model: {
          node: {text: '~', id: '/home/ubuntu', children: true, icon: 'jstree-folder'},
        },
        ctrl: {},
      },
      {
        application: 'file-tree',
        model: {
          node: {text: '/', id: '/', children: true, icon: 'jstree-folder'},
        },
        ctrl: {},
      },
    ];
    if (!$scope.directory || $scope.directory.startsWith("/home/ubuntu/") || $scope.directory === "/home/ubuntu") {
      $scope.activeSidebarTab = $scope.windowModels[0];
    } else {
      $scope.activeSidebarTab = $scope.windowModels[1];
    }
    $scope.onSelectNode = (node) => {
      if(!node.children) {
        $scope.filename = node.id.split('/').pop();
        $scope.directory = node.id.substrig(0, node.id.lastIndexOf('/'));
      }else{
        $scope.directory = node.id;
      }
    };
    $scope.isDisabled = () => {
      let scope = $scope;
      let active = scope.activeSidebarTab;
      console.log("scope=", scope);
      console.log("active=", active);
      const node = getSelected()[0];
      // const node = $scope.activeController.getSelected()[0];
      if(!node){
        return true;
      }
      if($scope.mode === 'open'){
        if(node.children){
          return true;
        }
      }else{
        if($scope.filename === ''){
          return true;
        }
      }
    };
    $scope.save = () => {
      let filename = `${$scope.directory}/${$scope.filename}`;
      $uibModalInstance.close(filename);
    };
    $scope.cancel = () => {
      $uibModalInstance.dismiss('cancel');
    };
  }
}

export class ModalContainerSaveFileService{
  /*@ngInject*/
  constructor(private $uibModal){
  }
  open(container, options, mode /*readMode*/):Promise<string>{
    return this.$uibModal.open({
      size: 'lg',
      template: require('./modalContainerSaveFile.html').default,
      // controller: 'ModalContainerSaveFileController',
      controller: ModalContainerSaveFileController,
      resolve: {
        container: container,
        options: options,
        mode: () => mode, /* 'open', 'save', 'new' */
        // readMode: readMode,
      },
    }).result;
  }
}
export default angular.module('paizacloudApp.modalContainerSaveFile', ['paizacloudApp'])
  // .controller('ModalContainerSaveFileController', ModalContainerSaveFileController)
  .service('ModalContainerSaveFileService', ModalContainerSaveFileService)
  .name;
